import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';

import GameService from '../../../../../services/game.service';
import TeamPlayerLogo from './playerLogo';
import PlayerStatDialog from '../../../leaders/status';
import SeasonContext from '../../../../../common/Context';

const TeamPlayerLogoList = ({ games, gameIds, teamId, setIds, t }) => {
    const { seasonFilter } = React.useContext(SeasonContext);
    const [playerList, setPlayerList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectArray, setSelectArray] = useState([]);
    const [statOpen, setStatOpen] = useState(false);
    const [currentPlayer, setCurrentPlayer] = useState(null);
    const [playerState, setPlayerState] = useState(null);

    let statClick = false;

    const handleSelectPlayer = (index) => {
        if (!statClick) {
            setSelectArray({ ...selectArray, [index]: !selectArray[index] });
            statClick = false;
        } else setSelectArray({ ...selectArray, [index]: false });
    };

    const handleDisplayList = async (player) => {
        statClick = true;

        // Get the correct team_id for the selected games
        // This handles players who have played for multiple teams
        let correctTeamId = teamId;
        try {
            const teamResult = await GameService.getPlayerTeamForGames(player.player_id, gameIds);
            if (teamResult && teamResult.length > 0) {
                correctTeamId = teamResult[0].team_id;
            }
        } catch (err) {
            console.error('Error fetching player team for games:', err);
        }

        const statsService = player.player_position_name === 'Goalkeeper'
            ? GameService.getGoalkeepersStatsAdvanceSummary
            : GameService.getPlayersStatsAdvanceSummary;

        statsService({
            seasonId: seasonFilter === 'none' ? null : seasonFilter.id,
            leagueId: null,
            gameId: null,
            teamId: correctTeamId,
            playerId: player.player_id,
            gameTime: null,
            courtAreaId: null,
            insidePaint: null,
            homeAway: null,
            gameResult: null
        }).then((res) => {
            setPlayerState(res[0]);
            setStatOpen(true);
            setCurrentPlayer(player);
        });
    };

    useEffect(() => {
        if (teamId !== -1 && gameIds.length > 0) {
            setLoading(true);
            setPlayerList([]);
            GameService.getGameCoachTeamPlayers(teamId, gameIds.join(',')).then((res) => {
                setPlayerList(res);
                setLoading(false);
                setSelectArray([]);
                res.map((item) => setSelectArray((old) => [...old, false]));
            });
        } else setPlayerList([]);
    }, [gameIds, teamId]);

    useEffect(() => {
        const ids = playerList.filter((item, index) => selectArray[index] === true).map((item) => item.player_id);

        setIds(ids);
    }, [selectArray]);

    return (
        <Box sx={{ minWidth: '600px' }}>
            {loading && (
                <div style={{ width: '100%', height: '100%', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </div>
            )}
            <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto auto auto auto auto auto auto', gap: '0px' }}>
                {playerList.map((item, index) => (
                    <Box
                        key={item.player_id + '_' + index}
                        sx={{ borderRadius: '10px', border: selectArray[index] ? '4px solid #17375E' : '4px solid white', cursor: 'pointer' }}
                        onClick={() => handleSelectPlayer(index)}
                    >
                        <TeamPlayerLogo player={item} onShow={handleDisplayList} />
                    </Box>
                ))}
            </Box>
            <PlayerStatDialog t={t} open={statOpen} onClose={() => setStatOpen(false)} player={currentPlayer} games={games} gameIds={gameIds} initialState={playerState} />
        </Box>
    );
};

export default TeamPlayerLogoList;
